import { jadeLocals } from 'cdnPreprocessor';

let params = {
    search: null,
    category: null,
    sub_category: null,
    product_type: null,
    min_price: null,
    max_price: null,
    csdc: null,
    csdc_email: null
  },
  template = require('pages/marketplace/marketplace.jade')(jadeLocals),
  url = (fragment) => `/${fragment}?search&category&sub_category&product_type&min_price&max_price&csdc&csdc_email`

export default ['$stateProvider',
  function($stateProvider) {
    $stateProvider
      .state('marketplace', { url: url('marketplace'), template, params })
      .state('marketplace-page', { url: url('marketplace/:page'), template, params });
  }
];


// WEBPACK FOOTER //
// ./source/client/pages/marketplace/marketplace.routes.js